import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import contentPropType from 'lib/CustomPropTypes/content';
import ShopButton from 'components/ShopButtonInfo/ShopButton';
import { getInfoForShopButtons } from 'lib/teaseUtils';
import { publicoHeadlineBrands } from 'lib/vertical';
import Link from 'components/Link/index';
import TeasePicture from 'components/TeasePicture/index';
import AIMS_FLAVORS from 'lib/aimsFlavors';
import OneByOne from './OneByOne';

function headline(headlineText, url, vertical) {
  const headlineColor = vertical === 'today' ? 'color-secondary' : 'gray-100';
  return (
    <h3
      className={classNames('bacon-cards-onebyone__product-headline', 'mb0 mr4 mt3',
        {
          'bacon-cards-onebyone__product-headline-publico-headline-brands': publicoHeadlineBrands.includes(vertical),
          'bacon-cards-onebyone__product-headline-non-publico-headline-brands': !publicoHeadlineBrands.includes(vertical),
        })}
      data-test="one-by-one-product__headline__header"
    >
      <Link
        to={url}
        className={classNames(
          'font-hed fw4',
          headlineColor,
          'bacon-cards-onebyone__product-headline-link',
          {
            'bacon-cards-onebyone__product-headline-link-publico-headline-brands': publicoHeadlineBrands.includes(vertical),
            'bacon-cards-onebyone__product-headline-link-non-publico-headline-brands': !publicoHeadlineBrands.includes(vertical),
          },
        )}
        data-test="one-by-one-product__headline__link"
      >
        {headlineText}
      </Link>
    </h3>
  );
}

function renderShopButtons(props) {
  // eslint-disable-next-line react/prop-types
  const { card: { isCustomAd } } = props;
  if (isCustomAd) {
    return null;
  }
  const infoForShopButtons = getInfoForShopButtons(props);
  const {
    list, productName, seller, productUrl: url,
  } = infoForShopButtons;

  return (
    <Link to={url} target="_blank" className={classNames('bacon-cards-onebyone__product-bacon-shop-button', 'db')}>
      <ShopButton
        additionalStyles={{
          shop: 'mt4',
          vendorName: 'founders-mono',
        }}
        block="BaconProduct"
        isLink
        isWaffle={false}
        isBacon
        listPrice={list}
        name={productName || ''}
        seller={seller.name || ''}
      />
    </Link>
  );
}


function renderPrice(listPrice, salePrice) {
  if (!listPrice) { return null; }

  return (
    <div className={classNames('mt4 founders-mono')}>
      {salePrice && (
        <div className="red b">
          $
          {salePrice}
        </div>
      )}
      <div className={classNames('gray-60 b', { 'strike fw5': salePrice })}>
        $
        {listPrice}
      </div>
    </div>
  );
}

function getDekDisplayText(dek, item) {
  return dek || item.description.primary;
}

function renderDescription(description) {
  if (!description) { return null; }

  return (
    <div className={classNames('mt2 publico-hed gray-80 lh-copy', 'bacon-cards-onebyone__product-description')}>
      {description}
    </div>
  );
}

const OneByOneProduct = (props, context) => {
  const {
    card: {
      computedValues = {},
      item = {},
      type,
      id,
      isLazyLoaded = true,
    } = {},
  } = props;

  if (!computedValues) {
    return null;
  }

  const { headline: headlineText = '', dek } = computedValues;
  const { vertical } = context;
  const sizes = {
    s: AIMS_FLAVORS.FOCAL_440x440,
  };
  const dekDisplayText = getDekDisplayText(dek, item);
  const { list, sale, productUrl: url } = getInfoForShopButtons(props);
  return (
    <OneByOne id={id}>
      <Link
        to={url}
        className={classNames(
          'db relative',
        )}
        data-test="one-by-one-product__tease-picture__link"
      >
        <TeasePicture
          computedValues={computedValues}
          lazyload={isLazyLoaded}
          responsiveFlavors={sizes}
          type={type}
        />
      </Link>
      {renderShopButtons(props)}
      {headline(headlineText, url, vertical)}
      {renderDescription(dekDisplayText)}
      {renderPrice(list, sale)}
    </OneByOne>
  );
};

OneByOneProduct.propTypes = {
  card: contentPropType,

};

OneByOneProduct.defaultProps = {
  card: {},
};

OneByOneProduct.contextTypes = {
  vertical: PropTypes.string,
};

export default OneByOneProduct;
